import request from '@/utils/request'
import api from './base-url.config'

// 有效的国家列表
export function siteListApi(params) {
  return request({
    url: api.siteList,
    method: 'get',
    params
  })
}

// 有效的国家列表
export function separateSiteListApi(params) {
  return request({
    url: api.separateSiteList,
    method: 'get',
    params
  })
}
export function siteConfigExtend(params) {
  return request({
    url: api.loginRegisterConfigExtend,
    method: 'get',
    params
  })
}

// 有效的国家列表
export function productUrl(params) {
  return request({
    url: api.productUrl,
    method: 'get',
    params
  })
}

// 国家切换时，根据国家编码获取对应国家信息以及国家配置信息
export function siteConfigApi(params) {
  return request({
    url: api.siteConfig,
    method: 'get',
    params
  })
}

export function siteConfigSeparateApi(params) {
  return request({
    url: api.siteConfigSeparate,
    method: 'get',
    params
  })
}

// 全部国家区号列表
export function mobileCountriesApi(params) {
  // debugger
  return request({
    url: api.mobileCountries,
    method: 'get',
    params
  })
}

// 根据用户的ip去请求用户当前的国家编码（用户id后端去获取解析，前端只需要调用接口获取到国家编码即可）
export function getSiteCodeApi(params) {
  return request({
    url: api.getSiteCode,
    method: 'get',
    params
  })
}

/**
 *
 * @param {FormData} data
 * @description
 * @returns
 */
export function pwValidateCheck(data) {
  return request({
    url: api.pwValidateCheck,
    method: 'post',
    data
  })
}

export function setPushConfigTmpToken(data) {
  return request({
    url: api.setPushConfigTmpToken,
    method: 'post',
    data
  })
}
